import { useLocalForageKey } from '../../../utils/local-storage/useLocalForageKey.hooks'

const STORAGE_KEY = 'retailerAgent.enabled'

export const useRetailerAgentEnabled = () => {
  const { data, setData, loading } = useLocalForageKey<boolean>(STORAGE_KEY)

  return {
    enabled: data ?? true,
    setEnabled: setData,
    loading,
  }
}
